import _ from 'lodash';
import { message } from 'antd';
import type { Reducer, Effect } from 'umi';
import type { ConnectState } from '@/models/connect';
import type { FetchComingSoonResp, ComingSoonStateType } from './coming-soon.data';
import { createComingSoon, fetchComingSoons } from '@/pages/AutomaticQuote/services';

export type ComingSoonModelType = {
  namespace: string;
  state: ComingSoonStateType;
  effects: {
    createComingSoon: Effect;
    fetchComingSoons: Effect;
  };
  reducers: {
    fetchComingSoonsSuccess: Reducer<ComingSoonStateType>;
  };
};

const Model: ComingSoonModelType = {
  namespace: 'comingSoon',

  state: {
    list: [],
    query: {
      page: 1,
      limit: 10,
    },
    total: 0,
  },

  effects: {
    *fetchComingSoons({ payload: updatedParams }, { call, put, select }) {
      const currentQuery = yield select((state: ConnectState) => state.comingSoon.query);

      const query = !_.get(updatedParams, 'type')
        ? _.omit({ ...currentQuery, ...updatedParams }, ['type'])
        : { ...currentQuery, ...updatedParams };

      const response: FetchComingSoonResp = yield call(fetchComingSoons, _.omitBy(query, _.isNil));

      yield put({
        type: 'fetchComingSoonsSuccess',
        payload: {
          list: response.list,
          total: response.total,
          query,
        },
      });
    },
    *createComingSoon({ payload }, { call, put }) {
      const response = yield call(createComingSoon, payload);

      if (response?.id) {
        message.success('Cảm ơn bạn đã đóng góp ý kiến');
        yield put({
          type: 'fetchComingSoons',
        });
      }
    },
  },
  reducers: {
    fetchComingSoonsSuccess(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
